import barraLogos from "@/assets/BarraLogos_PBA_PT.svg";

export default {
  name: 'FooterComponent',
  data() {
    return {
      barraLogos,
    };
  },
};
